'use strict';

class Parallax {

    constructor() {

        // get all the elements to be parallaxed
        const parallaxElements = document.querySelectorAll('[data-parallax]');

        // if there are elements
        if (parallaxElements) {

            const medium = window.matchMedia('(min-width: 768px)');
            const large = window.matchMedia('(min-width: 1024px)');
            const xlarge = window.matchMedia('(min-width: 1160px)');
    
            // function to calculate the multiplier
            function calculateScale(scale) {

                const originalScale = scale;

                if (xlarge.matches) {
                    scale = scale * 3.5;
                } else if (large.matches) {
                    scale = scale * 2.5;
                } else if (medium.matches) {
                    scale = scale * 1.5;
                }

                if ( !scale || isNaN(scale) ) {
                    return originalScale;
                } else {
                    return scale;
                }

            }
    
            // the parallax function
            const parallax = elements => {
                if ('undefined' !== elements && elements.length > 0) {
                    elements.forEach( element => {
                        let y = window.innerHeight - element.getBoundingClientRect().top
                        let scale = element.getAttribute('data-parallax-scale');
                        if ( !scale || isNaN(scale) ) {
                            scale = 0;
                        }
                        if (y > 0) {
    
                            if (element.getAttribute('data-parallax-dir') == 'invert') {
                                element.style.transform = 'translate3d(0, -' + (calculateScale(scale) * y) + 'px ,0)'
                            } else {
                                element.style.transform = 'translate3d(0, ' + (calculateScale(scale) * y) + 'px ,0)'
                            }
                        }
                    })
                }
            }
    
            // on window resize, reset parallax items
            window.addEventListener('resize', () => {
                parallax(parallaxElements)
            })
    
            // if element is in viewport, set its position
            parallax(parallaxElements);
    
            // call the function on scroll
            window.onscroll = () => {
                parallax(parallaxElements)
            }

        }

    }

}

module.exports = Parallax;